import {
  Box,
  Stack,
  Grid,
  Typography,
  IconButton,
  Button,
  TextField,
  Card,
  Dialog,
} from "@mui/material";
import { useList } from "src/hooks/useFetch.hook";
import { BaseTable } from "../BaseTable/BaseTable";
import { useSelector, useDispatch } from "react-redux";
import { tagListColumns } from "./Tags.constants";
import { useAccess } from "src/hooks/useAccess.hook";
import { FEATURE } from "src/util/enums";
import TagAttachChargerModal from "./TagAttachChargerModal";
import { dialogSlice } from "src/store/dailog/dailog.slice";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { CommonSearchbar } from "src/layouts/dashboard/Searchbar";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { Icon } from "@iconify/react";
import ExportCSV from "../ExportCsv/ExportCSV";
import { useGetDetail } from "src/hooks/useFetch.hook";
import { useSelectedTeam, useSelectedTeamState } from "src/hooks/useSelectedTeam";

export const TagList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hasCreateAccess = useAccess(FEATURE.TAG, "C");
  const isReadOnly = useAccess(FEATURE.TAG, "R");
  const { data: tags, isFetching } = useList("tags");
  const { open, data } = useSelector(({ dialog }) => dialog);
  const handleClose = () => dispatch(dialogSlice.actions.setDialog(false));
  const [tableData, setTableData] = useState();
  const { teamId } = useSelectedTeam();
  const { teamCurrencySymbol } = useSelectedTeamState();
  const { data: profileData, isFetching: isProfileFetching } = useGetDetail(
    "profile",
    { id: 0 }
  );
  const currentRole = profileData?.role?.find((role) => role.teamId === teamId);
  const hasTeamTypeT = currentRole?.teamType === "T";

  const rowOrCellClickRedirect = ({ id }) => {
    // if (isReadOnly) return;
    navigate(`/tag/${id}`);
  };

  useEffect(() => {
    if (!isFetching) {
      let data = [...(tags ?? [])];
      setTableData(data);
    }
  }, [isFetching, tags]);

  // Dynamic search handler for CommonSearchbar
  const handleSearching = (event) => {
    const dataToSearchFrom = tags ?? [];
    const searchValue = event.target.value.trim().toString().toLowerCase();
    if (searchValue) {
      const filteredDataArr = dataToSearchFrom.reduce(
        (filteredDataArr, currentObj) => {
          const relevantFields = [
            "tag",
            "parenttag",
            "expirydate",
            "balance_amount",
            "in_transaction",
            "blocked",
          ];
          const allValuesArr = Object.entries(currentObj)
            .filter(([key]) => relevantFields.includes(key))
            .map(([key, value]) =>
              key === "expirydate"
                ? yearFirstDateTimeFormat(value).toString()
                : value
                ? value.toString().toLowerCase()
                : ""
            );
          const searchResult = allValuesArr.find((value) =>
            value.includes(searchValue)
          );
          if (searchResult) filteredDataArr = [...filteredDataArr, currentObj];
          return filteredDataArr;
        },
        []
      );
      setTableData(filteredDataArr);
    } else setTableData([...(tags ?? [])]);
  };

  // Button style for header
  const headerBtnStyle = {
    minWidth: 180,
    fontWeight: 600,
    textAlign: "center",
    justifyContent: "center",
    borderRadius: 2,
    boxShadow: 1,
    px: 2,
    py: 1.2,
    display: "flex",
    alignItems: "center",
    transition: "all 0.2s cubic-bezier(.4,0,.2,1)",
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: 4,
    },
  };

  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3, p: { xs: 2, md: 3 }, mb: 3 }}>
      {/* Header Row: All buttons same size, centered text, aligned */}
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        flexWrap="wrap"
        mb={2}
        sx={{
          gap: 2,
          rowGap: 2,
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: {
            xs: "flex-start",
            md: "flex-start",
            lg: "flex-start",
          },
        }}
      >
        {hasTeamTypeT && !isReadOnly &&(
          <Button
            variant="contained"
            color="primary"
            startIcon={<Icon icon="eva:plus-fill" width={22} height={22} />}
            sx={headerBtnStyle}
            onClick={() => navigate("/tag/new")}
          >
            Add New RFID Tag
          </Button>
        )}
        <Button
          variant="outlined"
          color="primary"
          startIcon={<Icon icon="eva:bar-chart-fill" width={22} height={22} />}
          sx={headerBtnStyle}
          onClick={() => navigate("/rfid-usage-reports")}
        >
          Usage Reports
        </Button>
        {/* Export to Excel button styled as header button */}
        <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
          <ExportCSV
            rows={tableData || []}
            columns={tagListColumns(isReadOnly, teamCurrencySymbol)}
            csvMorphemes="auth_code"
            buttonSx={headerBtnStyle}
          />
        </Box>
        <Box sx={{ minWidth: { xs: "100%", sm: 220, md: 260 }, flex: 1 }}>
          <CommonSearchbar placeholder="Search" searchFunc={handleSearching} />
        </Box>
      </Stack>
      <BaseTable
        rows={tableData ?? []}
        isLoading={isFetching}
        columns={tagListColumns(isReadOnly, teamCurrencySymbol)}
        showExportCsvBtn={false}
        csvMorphemes="auth_code"
        rowOrCellClickRedirect={rowOrCellClickRedirect}
        pageSize={10}
        isReadOnly={isReadOnly}
        csvColumns={tagListColumns(isReadOnly, teamCurrencySymbol)}
      />
      <TagAttachChargerModal open={open} data={data} onClose={handleClose} />
    </Card>
  );
};
